import { render, staticRenderFns } from "./InvitationsTableList.vue?vue&type=template&id=de3b2b20&"
import script from "./InvitationsTableList.vue?vue&type=script&lang=js&"
export * from "./InvitationsTableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports